import React from 'react';

export default function Links(): JSX.Element {
  return (
    <div className='my-1'>
      <div className='text-blue-600 my-2'>
        <a
          target='_blank'
          href='https://snap-mobile.zendesk.com/hc/en-us/articles/14261745959579-Why-does-Snap-Raise-ask-for-personal-information'
          rel='noreferrer'
        >
          Why does Snap! Raise ask for personal information?
        </a>
      </div>
      <div className='text-blue-600 my-2'>
        <a
          target='_blank'
          href='https://snap-mobile.zendesk.com/hc/en-us/articles/14261280877595-How-will-this-impact-individual-taxes'
          rel='noreferrer'
        >
          How will this impact individual taxes?
        </a>
      </div>
      <div className='text-blue-600 my-2'>
        <a
          target='_blank'
          href='https://snap-mobile.zendesk.com/hc/en-us/articles/14261440619547-What-does-Snap-Raise-submit-during-the-Know-Your-Customer-process'
          rel='noreferrer'
        >
          What does Snap! Raise submit during the Know Your Customer process?
        </a>
      </div>
    </div>
  );
}
